// extracted by mini-css-extract-plugin
export var centerText = "_ft-8";
export var container = "_ft-0";
export var doughnutContainer = "_ft-7";
export var legend = "_ft-a";
export var legendItemColorDisplay = "_ft-b";
export var legendItemLabel = "_ft-d";
export var legendItemValue = "_ft-c";
export var lg = "_ft-5";
export var maxWidth = "_ft-9";
export var md = "_ft-4";
export var responsive = "_ft-6";
export var sm = "_ft-3";
export var xs = "_ft-2";
export var xxs = "_ft-1";